import { ChevronDownIcon, ChevronUpIcon } from '../../../../../assets/icons';
import { ReactNode } from 'react';
import styles from './style.module.scss';

/** Apply to a `Button` passed as the accordion `action` slot. */
export const accordionActionClassName = styles.accordion_action;

interface Props {
    title: ReactNode;
    open?: boolean;
    onToggle?: () => void;
    /** Replaces the chevron, e.g. the "Open Player" button. */
    action?: ReactNode;
    /** Preserves the whitespace of plain-text bodies. */
    preformatted?: boolean;
    children?: ReactNode;
};

function Accordion(props: Props) {
    const { title, open = false, onToggle, action, preformatted, children } = props;
    const Body = preformatted ? 'pre' : 'div';

    return (
        <div className={styles.accordion}>
            <div className={styles.accordion_header} onClick={onToggle}>
                <span>{title}</span>
                {action ?? (open ? <ChevronUpIcon /> : <ChevronDownIcon />)}
            </div>
            {open && children !== undefined && <Body className={styles.accordion_body}>
                {children}
            </Body>}
        </div>
    );
};

export default Accordion;
